import { Component, EventEmitter, Input, Output } from '@angular/core';
export interface AddButtonOption {
  show: boolean;
  text: string;
  class: string;
  icon: string;
}

export interface ListOption<T> {
  text: string;
  class: string;
  icon: string;
  action: (item: T, context?: unknown) => void;
}

export type KeyOf<T> = keyof T;
export type ListRender<T> = Partial<Record<keyof T, (x: T) => string>>;
export type HeadRender<T> = Partial<Record<keyof T, (x: string) => string>>;

export interface LinkConfig<T> {
  path?: (item: T) => string[];
  href?: (item: T) => string;
  params?: (item: T) => Record<string, string>;
}

export type LinkRender<T> = Partial<Record<keyof T, LinkConfig<T>>>;

export type CellClassRender<T> = Partial<
  Record<keyof T, (item: T) => string | string[] | Record<string, boolean>>
>;

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class ListComponent<T> {
  @Input() border = true;
  @Input() context?: unknown;
  @Input() title = '';
  @Input() dataSource: T[] = [];
  @Input() displayedColumns: (keyof T)[] = [];
  @Input() options: ListOption<T>[] = [];
  @Output() add = new EventEmitter<void>();
  //options
  @Input() addButtonOptions: AddButtonOption = {
    show: false,
    text: 'Add',
    class: 'btn btn-primary',
    icon: 'fas fa-plus',
  };
  @Input() noDataText: string | null = null;
  @Input() renders: ListRender<T> = {};
  @Input() headRenders: HeadRender<T> = {};
  @Input() linkRenders: LinkRender<T> = {};
  @Input() cellClassRenders: CellClassRender<T> = {};

  onAdd() {
    this.add.emit();
  }
  onClick(option: ListOption<T>, value: T): void {
    option.action(value, this.context);
  }
}
